import * as React from 'react';
import styled from 'styled-components';
import { HeaderLogo, HeaderMenu } from '../../components';

class HeaderBar extends React.Component<any, any> {
  render() {
    const Div = styled.div`
      display: -webkit-flex; 
      display: flex; 
      align-items: center; 
      background-color: #fff; 
      border-bottom: 1px solid #D3E3F4;
      height: 50px;
      justify-content: space-between; 
      position: relative;
      flex-wrap:nowrap;
    `;
    return (
      <Div>
        <HeaderLogo />
        <HeaderMenu user={this.props.user} />
      </Div>
    );
  }
}

export default HeaderBar;
